import { useEffect, useRef, useState } from "react";
import {
    Col,
    Image,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BsEyeFill } from "react-icons/bs";
import dahabiya from "assets/img/payment/EDAHABIA.png";
import cib from "assets/img/payment/cib.png";
import delivery from "assets/img/payment/delivery.jpeg";
import satimNum from "assets/img/payment/satimnum.png";
import epayment from "assets/img/payment/epayment.jpg";
import agencyPayment from "assets/img/payment/agency-payment.jpg";
import { useNavigate } from "react-router-dom";
import useToggle from "hooks/useToggle";
import useFlightConfirmation from "hooks/flight/useFlightConfirmation";
import ReCAPTCHA from "react-google-recaptcha";
import { SiGooglemaps } from "react-icons/si";

const paymentMethodsInfos = [
    {
        images: [dahabiya, cib],
        fr: [
            "Cliquez sur le bouton « Payer » pour continuer, vous allez être redirigé vers la page de paiement d'Algérie poste, une fois les informations de paiement saisies, vous devez utiliser le mot de passe à usage unique reçu par SMS au numéro de téléphone lié à la carte.",
            "Une fois l'opération de paiement terminée, vous serez redirigé encore une fois sur notre site, et vous recevrez une confirmation de réservation et votre billet par email.",
            "Le plafond de paiement de la carte Edahabia est fixé à 200 000 DA par jour, avant de procéder au paiement, veuillez-vous assurer que le prix de votre billet est en dessous de ce montant.",
            "Avant de procéder au paiement de votre billet d’avion, assurez-vous que le plafond de paiement journalier de votre carte CIB vous le permet.",
            "Pour toute aide, veuillez contacter notre support au numéro affiché à droite.",
        ],
        en: [
            "Click on the 'Pay' button to continue. You will be redirected to the Algeria Post payment page. Once you enter the payment details, you must use the one-time password that you will receive via SMS to the phone number linked to the card.",
            "Once the payment operation is completed, you will be redirected again to our site, and you will receive a booking confirmation and your ticket by email.",
            "The payment ceiling of the Edahabia card is set at 200,000 DA per day. Before proceeding with the payment, please ensure that the price of your ticket is below this amount.",
            "Before proceeding with the payment of your flight ticket, make sure that the daily payment limit of your CIB card allows it.",
            "For any assistance, please contact our support at the number displayed on the right.",
        ],
        ar: [
            "اضغط على زر 'الدفع' للمتابعة. سيتم توجيهك إلى صفحة الدفع الخاصة ببريد الجزائر. بمجرد إدخال تفاصيل الدفع، يجب عليك استخدام كلمة المرور ذات الاستخدام الواحد التي ستتلقاها عبر رسالة نصية على رقم الهاتف المرتبط بالبطاقة.",
            "بمجرد اكتمال عملية الدفع، سيتم إعادتك إلى موقعنا الإلكتروني وستتلقى تأكيد الحجز وتذكرتك عبر البريد الإلكتروني.",
            "الحد الأقصى للدفع اليومي لبطاقة الذهبية محدد بـ 200,000 دينار جزائري. قبل المتابعة بالدفع، تأكد من أن سعر التذكرة أقل من هذا الحد.",
            "قبل المتابعة بدفع تذكرة الطيران الخاصة بك، تأكد من أن الحد الأقصى للدفع اليومي لبطاقة CIB يسمح بذلك.",
            "لأي مساعدة أو دعم، يرجى الاتصال بنا على الرقم المعروض على اليمين.",
        ],
    },
    {
        images: [delivery],
        fr: [
            "Afin de confirmer votre billet d’avion, le paiement et la livraison de ce billet doivent s’effectuer avant minuit.",
            "Pour faire livrer votre billet d’avion dans les plus brefs délais, veuillez sélectionner votre ville et inscrire l’adresse de livraison. Nous vous contacterons dans quelques instants pour convenir de cette livraison.  (Nous vous prions de bien vouloir préparer le montant à payer avant l’arrivée de notre livreur).",
            "Le service de livraison est disponible dans toutes les wilayas d’algerie.",
        ],
        en: [
            "To confirm your flight ticket, the payment and delivery of this ticket must be completed before midnight.",
            "To have your flight ticket delivered as quickly as possible, please select your city and enter the delivery address. We will contact you shortly to arrange this delivery. (Please ensure you have the amount to pay ready before our delivery person arrives).",
            "Delivery service is available in all Algerian states.",
        ],
        ar: [
            "لتأكيد تذكرة الطيران الخاصة بك، يجب إكمال الدفع وتسليم هذه التذكرة قبل منتصف الليل.",
            "للحصول على تذكرتك بسرعة، يرجى اختيار مدينتك وإدخال عنوان التسليم. سنتصل بك قريبًا لترتيب عملية التسليم. (يرجى التأكد من تجهيز المبلغ المطلوب دفعه قبل وصول موظف التوصيل).",
            ".خدمة التوصيل متوفرة في جميع ولايات الجزائر",
        ],
    },
    {
        images: [agencyPayment],
        fr: [
            "Vous pouvez confirmer votre réservation et régler le montant directement dans notre agence.",
            "Notre équipe est disponible pour vous accueillir et finaliser votre billet d’avion sur place.",
            "Veuillez vous présenter à notre agence avec le numéro de réservation reçu par email. (Nous vous prions de bien vouloir préparer le montant exact à payer).",
        ],
        en: [
            "You can confirm your booking and pay directly at our agency.",
            "Our team is available to welcome you and finalize your flight ticket on site.",
            "Please come to our agency with the booking number received by email. (Please prepare the exact amount to pay).",
        ],
        ar: [
            "يمكنك تأكيد حجزك ودفع المبلغ مباشرة في وكالتنا.",
            "فريقنا متاح لاستقبالكم وإتمام إجراءات تذكرة الطيران على الفور.",
            "يرجى التوجه إلى وكالتنا مع رقم الحجز المستلم عبر البريد الإلكتروني. (يرجى إحضار المبلغ المحدد بالضبط).",
        ],
    },
];

const PaymentArea = () => {
    const { t, i18n } = useTranslation();
    const { loading, confirmBooking, showRequestBooking } =
        useFlightConfirmation();
    const { isOpen, toggle } = useToggle();
    const { isOpen: showDeliveryModal, toggle: toggleDeliveryModal } =
        useToggle();
    const [selectedMethod, setSelectedMethod] = useState(0);
    const recaptchaRef = useRef();
    const [captchaChecked, setCaptchaChecked] = useState(false);
    const [captchaToken, setCaptchaToken] = useState(null);
    const navigate = useNavigate();

    const handleClickTos = () => {
        const baseUrl = window.location.origin;
        const fullUrl = `${baseUrl}/TOS`;
        window.open(fullUrl, "_blank");
    };
    const handleCaptchaVerify = (token) => {
        console.log(token);
        setCaptchaToken(token);
        setCaptchaChecked(true);
    };
    const handleCaptchaExpired = () => {
        console.log("expired");
        recaptchaRef.current.reset();       
        setCaptchaChecked(false);
        setCaptchaToken(null);
    };
    const backToHome = () => {
        navigate("/");
    };
    useEffect(() => {
        if (showRequestBooking) {
            toggleDeliveryModal();
        }
    }, [showRequestBooking, toggleDeliveryModal]);

    return (
        <>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    toggle();
                }}
                className="flex flex-col w-full p-3 border border-border-color rounded-md"
            >
                <div className="d-sm-flex justify-content-sm-between align-items-center mb-4">
                    <h6 className="font-semibold text-base">
                        {t("weAccept")} :
                    </h6>
                    <ul className="list-inline mb-0 g-3">
                        <li className="list-inline-item mb-0">
                            <input
                                type="radio"
                                className="btn-check peer"
                                name="flightOptions"
                                id="btn-check-c1"
                                onClick={() => setSelectedMethod(0)}
                                checked={selectedMethod === 0}
                            />
                            <label
                                className="btn btn-sm duration-200 peer-checked:bg-hover-color peer-checked:text-main-color peer-checked:border-main-color"
                                htmlFor="btn-check-c1"
                            >
                                {t("cateCIB/EDAHABIA")}
                            </label>
                        </li>
                        <li className="list-inline-item mb-0">
                            <input
                                type="radio"
                                className="btn-check peer"
                                name="flightOptions"
                                id="btn-check-c2"
                                checked={selectedMethod === 1}
                                onClick={() => setSelectedMethod(1)}
                            />
                            <label
                                className="btn btn-sm duration-200 peer-checked:bg-hover-color peer-checked:text-main-color peer-checked:border-main-color"
                                htmlFor="btn-check-c2"
                            >
                                {t("cashOnDelivery")}
                            </label>
                        </li>
                        <li className="list-inline-item mb-0">
                            <input
                                type="radio"
                                className="btn-check peer"
                                name="flightOptions"
                                id="btn-check-c3"
                                checked={selectedMethod === 2}
                                onClick={() => { setSelectedMethod(2); }}
                            />
                            <label
                                className="btn btn-sm duration-200 peer-checked:bg-hover-color peer-checked:text-main-color peer-checked:border-main-color"
                                htmlFor="btn-check-c3"
                            >
                                {t("agencyPayment") || "Paiement en agence"}
                            </label>
                        </li>
                    </ul>
                </div>
                <Row className="g-3">
                    {paymentMethodsInfos[selectedMethod].images.map(
                        (image, index) => (
                            <Col key={index} xs={12} sm={6} className="mb-3">
                                <Image src={image} alt="payment method" fluid />
                            </Col>
                        )
                    )}
                    {selectedMethod === 2 && (
                        <Col xs={12}>
                            <a
                                href="https://www.google.com/maps/search/Aquaterra+Travel+Alger"
                                target="_blank"
                                rel="noreferrer"
                                className="inline-flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-xl transition-colors font-medium text-sm"
                            >
                                <SiGooglemaps size={16} />
                                {t("findAgencyOnMap") || "Trouver notre agence sur Maps"}
                            </a>
                        </Col>
                    )}
                    {paymentMethodsInfos[selectedMethod][i18n.language].map(
                        (text, index) => (
                            <Col key={index} xs={12}>
                                <p className="mt-1">{text}</p>
                            </Col>
                        )
                    )}
                    <Col xs={12}>
                        <div className="flex items-center gap-2 ">
                            <label htmlFor="tos" className="flex items-center">
                                <input
                                    style={{ cursor: "pointer" }}
                                    className="form-check-input  mt-0 me-1"
                                    type="checkbox"
                                    required
                                    id="popolarType1"
                                    name="tos"
                                />
                                {t("IAccept")}
                            </label>

                            <div
                                onClick={handleClickTos}
                                variant="link"
                                className="p-0 mb-0 s-link flex flex-row items-center cursor-pointer "
                            >
                                <div className="">
                                    <BsEyeFill />
                                </div>
                                <div className="">{t("terms&Conditions")}</div>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12}>
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey="6Ld_DrUZAAAAAK--DYvMSC8s0ZWuzmJcWhPI481l"
                            onChange={handleCaptchaVerify}
                            onExpired={handleCaptchaExpired}
                        />
                    </Col>
                    <Row className="g-3">
                        <Col xs={12} sm={6}>
                            <button
                                onClick={() => navigate("/flight-search")}
                                className="btn btn-outline-danger w-100"
                            >
                                {t("cancel")}
                            </button>
                        </Col>
                        <Col xs={12} sm={6}>
                            <button
                                type="submit"
                                disabled={!captchaChecked}
                                className="btn bg-main-color text-white w-100 "
                            >
                                <Image
                                    className="w-10 inline-block mr-2"
                                    loading="lazy"
                                    src={epayment}
                                    alt="e-payment"
                                />
                                {t("validate")}
                            </button>
                        </Col>
                    </Row>
                    {selectedMethod === 0 && (
                        <p className="d-flex align-items-center justify-content-start ">
                            {t("callSATIM")}
                            <Image
                                width={100}
                                style={{
                                    marginInlineStart: 10,
                                }}
                                src={satimNum}
                                alt="call 3020"
                                fluid
                            />
                        </p>
                    )}
                </Row>
            </form>
            <Modal
                show={isOpen}
                onHide={toggle}
                size="lg"
                className="fade"
                id="cancellation"
                aria-hidden="true"
            >
                <ModalHeader>
                    <h5 className="modal-title">Confirmation</h5>
                    <button
                        type="button"
                        onClick={toggle}
                        className="btn-close"
                    />
                </ModalHeader>
                <ModalBody className="p-3">
                    <h6 className="text-center">
                        Voulez-vous vraiment confirmer votre réservation ?
                    </h6>
                    <Row className="g-3 justify-content-center m-4">
                        <Col xs={6} sm={4}>
                            <button
                                onClick={toggle}
                                className="btn btn-outline-danger w-100"
                            >
                                {t("cancel")}
                            </button>
                        </Col>
                        <Col xs={6} sm={4}>
                            <button
                                disabled={loading}
                                onClick={() => {
                                    const method =
                                        selectedMethod === 0
                                            ? "CIB"
                                            : "DELIVERY";
                                    toggle();
                                    confirmBooking(method, captchaToken);
                                }}
                                className="btn bg-main-color text-white w-100 "
                            >
                                {loading ? t("loading") : t("confirm")}
                            </button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
            <Modal
                show={showDeliveryModal}
                onHide={backToHome}
                size="lg"
                className="fade"
                id="cancellation"
                aria-hidden="true"
            >
                <ModalHeader>
                    <h5 className="modal-title">{t("success")}</h5>
                    <button
                        type="button"
                        onClick={backToHome}
                        className="btn-close"
                    />
                </ModalHeader>
                <ModalBody className="p-3">
                    <h6 className="text-center">{t("deliverySuccess")}</h6>
                    <Row className="g-3 justify-content-center m-4">
                        <Col xs={6} sm={4}>
                            <button
                                onClick={backToHome}
                                className="btn  bg-main-color text-white w-100 "
                            >
                                {t("return")}
                            </button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </>
    );
};

export default PaymentArea;
